import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';

@Component({})
class EdButtonIcon extends Vue {
    @Prop({type: Boolean, default: false}) readonly disabled!: boolean;
    @Prop({type: Boolean, default: false}) readonly isPrimary!: boolean;
    @Prop({ type: Number, default: null }) readonly hoverSize!: number;
    @Prop({ type: Number, default: null }) readonly buttonWidth!: number;
    @Prop({ type: Number, default: null }) readonly buttonHeight!: number;

    get computedStyles() {
        const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--ed-color-green').trim();


        return {
            '--button-width': `${this.buttonWidth}px`,
            '--button-height': `${this.buttonHeight}px`,
            '--button-hover-size': `${this.hoverSize}px`,
            '--icon-color': this.isPrimary ? primaryColor : 'white',
        };
    }

    get addButtonClass() {
        return {
            'ed-button-icon--disabled': this.disabled,
        };
    }

    buttonAction() {
        if (!this.disabled) {
            this.$emit('clicked');
        }
    }
}


export default Vue.component('ed-button-icon', EdButtonIcon);